import React from 'react';
import * as mobx from 'mobx';
import { FormattedMessage } from 'react-intl';
import { IFiltersView, ISelectedFilter } from '../../../../../api/events.dao';
import { SHORT_PLAIN_TEXT_LENGTH } from '../../../../../constants/common.constants';

export default class FilteredViewFormVM {
    @mobx.observable
    public viewName = '';

    @mobx.observable
    public isSubmitted = false;

    @mobx.observable
    public isSaving = false;

    constructor(
        private onSave: (view: IFiltersView) => Promise<void>,
        public onClose: () => void,
        public selectedFilters: ISelectedFilter[]
    ) { }

    public handleSaveView = async () => {
        mobx.runInAction(() => {
            this.isSubmitted = true;
        });

        if (this.getViewNameError()) return;
        const trimmedViewName = this.viewName.trim();

        mobx.runInAction(() => {
            this.isSaving = true;
        });
        await this.onSave({
            filterViewName: trimmedViewName,
            filters: this.selectedFilters
        });
        mobx.runInAction(() => {
            this.isSaving = false;
        });
    };

    @mobx.action
    public changeViewName = (value: string): void => {
        this.viewName = value;
    };

    public getViewNameError = (): JSX.Element | null => {
        if (this.viewName.trim()) {
            if (this.viewName.length > SHORT_PLAIN_TEXT_LENGTH) {
                return <FormattedMessage
                    id='oe.validation.tooLong'
                    defaultMessage='Too long - max length is 255 characters'
                    description='Error message text'
                />;
            }
            return null;
        }
        return <FormattedMessage
            defaultMessage='Filtered View Name is required'
            id='oe.eventTracker.filteredViewNameIsRequired'
            description='Error message in popover'
        />;
    };
}
